module.exports = __webpack_public_path__ + "img/catalina-becerra.46d4349a.jpg";